import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eaf1d516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plant-pict" }
const _hoisted_2 = ["src", "alt"]

import { computed } from 'vue'
import { MinMax } from '@/types/api'
import { plantsService } from '@/di/services'

interface Props {
  name: string,
  value: MinMax,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantMinMax',
  props: {
    name: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
  name: string,
  value: MinMax,
};



const imageSource = computed((): string => plantsService.buildMinMaxImage(props.name))

const text = computed((): string => {
  if (props.value.min === null && props.value.max === null) {
    return ''
  }

  if (props.value.min === null && props.value.max !== null) {
    return `more then ${props.value.max} m`
  }

  if (props.value.min !== null && props.value.max === null) {
    return `from ${props.value.min} m`
  }

  return `${props.value.min} - ${props.value.max} m`
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(imageSource),
      alt: __props.name,
      class: "me-1"
    }, null, 8, _hoisted_2),
    _createElementVNode("span", null, _toDisplayString(_unref(text)), 1)
  ]))
}
}

})